import { Badge, StyleProps } from "@chakra-ui/react";
import { FundFamilyStateMachineFieldsEnum } from "gen/model/fundFamilyStateMachineFieldsEnum";
import { useTranslation } from "react-i18next";

const stateToBadgeColor = {
  [FundFamilyStateMachineFieldsEnum.draft]: "warning",
  [FundFamilyStateMachineFieldsEnum.fundraising]: "eggplant",
  [FundFamilyStateMachineFieldsEnum.active]: "success",
  [FundFamilyStateMachineFieldsEnum.dissolved]: "error",
  [FundFamilyStateMachineFieldsEnum.deleted]: "error",
} as const satisfies { [key in FundFamilyStateMachineFieldsEnum]: string };

export interface FundFamilyStateBadgeProps extends StyleProps {
  state: FundFamilyStateMachineFieldsEnum;
}

export const FundFamilyStateBadge: React.FC<FundFamilyStateBadgeProps> = ({
  state,
  ...props
}) => {
  const { t } = useTranslation(["enums"]);
  const color = stateToBadgeColor[state];
  return (
    <Badge variant="subtle" colorScheme={color} {...props}>
      {t(`enums:FundFamilyStateMachineFieldsEnum.${state}`)}
    </Badge>
  );
};
